import React from "react";

function ReservationCard({ res, onEdit }) {
    return (
        <li className="reservation-card">
            <div className="card-header">
                <h4>{res.customerName}</h4>
                <span className={`status ${res.status?.toLowerCase()}`}>
                    {res.status}
                </span>
            </div>
            <div className="">
                <div className="card-body">
                    <p><strong>📞</strong> {res.mobileNumber}</p>
                    <div className="row">
                        <p><strong>📅</strong> {res.reservationDate.split("T")[0]}</p>
                        <p><strong>⏰</strong> {res.reservationTime}</p>
                    </div>
                    <div className="row">
                        <p><strong>👥</strong> {res.numberOfGuests} guests</p>
                        <p><strong>🍽️</strong> T-{res.restaurantTable?.tableName}</p>
                    </div>
                </div>

                <div>
                   <button className="card-edit-btn" onClick={() => onEdit(res)}>
                        ✎ Edit
                    </button>
                </div>
            </div>
        </li>
    );
}

export default ReservationCard;